import React from "react";

// core components
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import AccountSecurityCard from "./AccountSecurityCard.jsx";

const ChangePassword = props => {
  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <AccountSecurityCard />
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default ChangePassword;
